@import '../../global/utility/full-width';

ui-cms-slider {
  display: block;

  .full-width {
    @include full-width;
  }

  &.navigation-hide {
    sd-carousel::part(navigation) {
      display: none;
    }
  }

  sd-carousel {
    sd-carousel-item {
      > * {
        height: 100%;
        width: 100%;
      }
    }

    &.inside-container::part(autoplay-controls) {
      margin-right: 2rem;
    }

    @media screen and (max-width: 1315px) and (min-width: 1200px) {
      &.inside-container::part(autoplay-controls) {
        margin-right: calc(2rem + (1315px - 100vw) * 0.4);
      }
    }

    &.inside-container::part(base) {
      margin-bottom: 0.25rem;
    }
  }
}
